// Reducer

import { REQUEST, SUCCESS, FAILURE } from 'app/shared/util/action-type.util';
import { ACTION_TYPES } from './actions';
import { ClaimState, initialState } from './state';

export default (state: ClaimState = initialState, action): ClaimState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.GET_CLAIMS_BY_CLIENT):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_CLAIMS_BY_CLIENT): {
      return {
        ...state,
        claimsList: action.payload.data,
        loading: false,
        page: 1,
      };
    }

    case FAILURE(ACTION_TYPES.GET_CLAIMS_BY_CLIENT): {
      return {
        ...initialState,
        loading: false,
      };
    }

    case REQUEST(ACTION_TYPES.Get_Claims_Clients_For_Active_Subscription):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.Get_Claims_Clients_For_Active_Subscription): {
      return {
        ...state,
        claimsList: action.payload.data,
        loading: false,
      };
    }

    case FAILURE(ACTION_TYPES.Get_Claims_Clients_For_Active_Subscription): {
      return {
        ...initialState,
        loading: false,
      };
    }

    // ok
    case REQUEST(ACTION_TYPES.GET_CLAIM_SUBSCRIPTION):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_CLAIM_SUBSCRIPTION): {
      return {
        ...state,
        claimModel: {
          ...state.claimModel,
          subscription: action.payload.data,
        },
        loading: false,
      };
    }

    case FAILURE(ACTION_TYPES.GET_CLAIM_SUBSCRIPTION): {
      return {
        ...initialState,
        loading: false,
      };
    }

    // ok
    case REQUEST(ACTION_TYPES.GET_PAPER_AND_DOCUMENT):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_PAPER_AND_DOCUMENT): {
      return {
        ...state,
        claimModel: {
          ...state.claimModel,
          paperAndDocument: action.payload.data,
        },
        loading: false,
      };
    }

    case FAILURE(ACTION_TYPES.GET_PAPER_AND_DOCUMENT): {
      return {
        ...initialState,
        loading: false,
      };
    }

    // ok
    case REQUEST(ACTION_TYPES.GET_CLAIM):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_CLAIM): {
      return {
        ...state,
        claimModel: { ...state.claimModel, claim: action.payload.data },
        loading: false,
      };
    }

    case FAILURE(ACTION_TYPES.GET_CLAIM): {
      return {
        ...initialState,
        loading: false,
      };
    }

    // ok
    case REQUEST(ACTION_TYPES.GET_CLAIM_EVENTS):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_CLAIM_EVENTS): {
      return {
        ...state,
        claimModel: { ...state.claimModel, claimEvent: action.payload.data },
        loading: false,
      };
    }

    case FAILURE(ACTION_TYPES.GET_CLAIM_EVENTS): {
      return {
        ...initialState,
        loading: false,
      };
    }

    // ok
    case REQUEST(ACTION_TYPES.GET_BENEFIT):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_BENEFIT): {
      return {
        ...state,
        claimModel: { ...state.claimModel, benefit: action.payload.data },
        loading: false,
      };
    }

    case FAILURE(ACTION_TYPES.GET_BENEFIT): {
      return {
        ...initialState,
        loading: false,
      };
    }

    case ACTION_TYPES.SET_PAGE: {
      return {
        ...state,
        page: action.payload.page,
      };
    }

    case ACTION_TYPES.RESET_CLAIMS: {
      return {
        ...initialState,
      };
    }

    case REQUEST(ACTION_TYPES.UPLOAD_CLAIMS):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.UPLOAD_CLAIMS): {
      return {
        ...state,
        claimsList: action.payload.data,
        loading: false,
        page: 1,
      };
    }

    case FAILURE(ACTION_TYPES.UPLOAD_CLAIMS): {
      return {
        ...initialState,
        loading: false,
      };
    }

    case REQUEST(ACTION_TYPES.GET_CLAIM_LIST_BY_SUBSCRIPTION_NUMBER):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_CLAIM_LIST_BY_SUBSCRIPTION_NUMBER): {
      return {
        ...state,
        claimsList: action.payload.data,
        loading: false,
      };
    }

    case FAILURE(ACTION_TYPES.GET_CLAIM_LIST_BY_SUBSCRIPTION_NUMBER): {
      return {
        ...initialState,
        loading: false,
      };
    }

    case REQUEST(ACTION_TYPES.GET_CLAIM_LIST_BY_SUBSCRIPTION_NUMBER_FOR_CONTRACT_DETAILS):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_CLAIM_LIST_BY_SUBSCRIPTION_NUMBER_FOR_CONTRACT_DETAILS): {
      return {
        ...state,
        claimListForContract: action.payload.data,
        loading: false,
      };
    }

    case FAILURE(ACTION_TYPES.GET_CLAIM_LIST_BY_SUBSCRIPTION_NUMBER_FOR_CONTRACT_DETAILS): {
      return {
        ...initialState,
        loading: false,
      };
    }
    

    case REQUEST(ACTION_TYPES.DECLARE_SINISTRE_BY_SUBSCRIPTION_NUMBER):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.DECLARE_SINISTRE_BY_SUBSCRIPTION_NUMBER): {
      return {
        ...state,
        redirectLink: action.payload.data,
        loading: false,
      };
    }

    case ACTION_TYPES.EMPTY_REDIRECT_LINK: {
      return {
        ...state,
        redirectLink: null,
        loading: false,
      };
    }

    case FAILURE(ACTION_TYPES.DECLARE_SINISTRE_BY_SUBSCRIPTION_NUMBER): {
      return {
        ...initialState,
        loading: false,
      };
    }

    default:
      return state;
  }
};
